import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';

import { FormattedMessage } from 'react-intl';

import DistanceIcon from '-!svg-react-loader!./assets/img/distance.svg?name=DistanceIcon';
import DurationIcon from '-!svg-react-loader!./assets/img/duration.svg?name=DurationIcon';
import DepositIcon from '-!svg-react-loader!./assets/img/deposit.svg?name=DepositIcon';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import Item from './item';
import messages from './messages';

import reducer from './reducer';
import saga from './saga';

import { displayOffers, offerSelected } from './actions';
import { makeSelectDisplayOffers, makeSelectOfferSelector } from './selectors';
import './selector.scss';
import { default as OfferPrice } from '../OfferPrice/';

class OfferDetailsSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deposit: props.selectedOffer.deposit,
      distance: props.selectedOffer.distance,
      duration: props.selectedOffer.duration,
      monthly_rate: props.selectedOffer.monthly_rate,
      ref: props.selectedOffer.ref,
    };

    const deposits = [];
    const distances = [];
    const durations = [];

    props.offers.map(item => {
      deposits.push(item.deposit);
      distances.push(item.distance);
      durations.push(item.duration);
    });

    this.deposits = [...new Set(deposits)].sort();
    this.distances = [...new Set(distances)].sort();
    this.durations = [...new Set(durations)].sort();
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedOffer.deposit !== this.props.selectedOffer.deposit ||
      prevProps.selectedOffer.distance !== this.props.selectedOffer.distance ||
      prevProps.selectedOffer.duration !== this.props.selectedOffer.duration ||
      prevProps.selectedOffer.monthly_rate !==
        this.props.selectedOffer.monthly_rate ||
      prevProps.selectedOffer.ref !== this.props.selectedOffer.ref
    ) {
      this.setState(() => ({
        deposit: this.props.selectedOffer.deposit,
        distance: this.props.selectedOffer.distance,
        duration: this.props.selectedOffer.duration,
        monthly_rate: this.props.selectedOffer.monthly_rate,
        ref: this.props.selectedOffer.ref,
      }));
    }
  }

  async handleOnClick(e, field, value) {
    e.preventDefault();
    await this.setState({ [field]: parseInt(value) });
    const newSelected = this.searchSelectedOffer();
    this.setState(() => ({
      monthly_rate: newSelected.monthly_rate,
      ref: newSelected.ref,
    }));
  }

  handleOnSaveClick = e => {
    e.preventDefault();
    this.props.selectOffer({
      ref: this.state.ref,
      distance: this.state.distance,
      duration: this.state.duration,
      deposit: this.state.deposit,
      monthly_rate: this.state.monthly_rate,
    });
    this.props.close();
  };

  searchSelectedOffer = () =>
    this.props.offers.filter(
      item =>
        parseInt(item.deposit) === this.state.deposit &&
        parseInt(item.distance) === this.state.distance &&
        parseInt(item.duration) === this.state.duration,
    )[0];

  render() {
    const { openModal, selectedOffer } = this.props;
    const { deposit, distance, duration, monthly_rate } = this.state;
    return (
      <Modal
        isOpen={openModal}
        toggle={this.props.close}
        className="right-side-modal OfferDetailsSelectorContent"
      >
        <div className="modal-header">
          <div className="modal-title">
            <FormattedMessage {...messages.changeOfferTitle} />
          </div>
          <button className="close" type="button" onClick={this.props.close}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <ModalBody className="component-modal-body no-gutters no-padding">
          <div className="title">
            <FormattedMessage {...messages.changeDuration} />
          </div>
          <div className="detail-item">
            {this.durations.map((item, index) => (
              <Item
                key={index}
                value={`${item} mesi`}
                description={messages.duration.defaultMessage}
                iconComponent={<DurationIcon />}
                onClick={event => this.handleOnClick(event, 'duration', item)}
                selected={duration === item}
              />
            ))}
          </div>
          <div className="title">
            <FormattedMessage {...messages.changeDeposit} />
          </div>
          <div className="detail-item">
            {this.deposits.map((item, index) => (
              <Item
                key={index}
                value={parseInt(item).toLocaleString('it')}
                description={messages.deposit.defaultMessage}
                iconComponent={<DepositIcon />}
                onClick={event => this.handleOnClick(event, 'deposit', item)}
                selected={deposit === item}
              />
            ))}
          </div>
          <div className="title">
            <FormattedMessage {...messages.changeDistance} />
          </div>
          <div className="detail-item">
            {this.distances.map((item, index) => (
              <Item
                key={index}
                value={parseInt(item).toLocaleString('it')}
                description={messages.distance.defaultMessage}
                iconComponent={<DistanceIcon />}
                onClick={event => this.handleOnClick(event, 'distance', item)}
                selected={distance === item}
              />
            ))}
          </div>
          <OfferPrice price={parseInt(monthly_rate)} />
          <div className="text-center">
            <button
              className="btn-action"
              type="button"
              onClick={this.handleOnSaveClick}
            >
              <FormattedMessage {...messages.action} />
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

OfferDetailsSelector.defaultProps = {
  offers: [],
};

OfferDetailsSelector.propTypes = {
  offers: PropTypes.array,
  openModal: PropTypes.bool,
};

export function mapDispatchToProps(dispatch) {
  return {
    close: () => dispatch(displayOffers(false)),
    selectOffer: offer => dispatch(offerSelected(offer)),
  };
}

const mapStateToProps = createStructuredSelector({
  openModal: makeSelectDisplayOffers(),
  selectedOffer: makeSelectOfferSelector(),
});

const withReducer = injectReducer({ key: 'offerDetailsSelector', reducer });
const withSaga = injectSaga({ key: 'offerDetailsSelector', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(OfferDetailsSelector);
